import React, { Component } from 'react';
import SimpleReactValidator from 'simple-react-validator';
import Notifications, { notify } from 'react-notify-toast';
import Context from '../../Context';
import Header from "../../Layouts/Header";
import { withTranslation } from 'react-i18next';

class Status extends Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      status: false,
    }
    this.validator = new SimpleReactValidator();
  }

  handleUserData = (event) => {
    this.setState({
      [event.target.id]: event.target.value
    })
  }

  submitUserDetails = (event) => {
    event.preventDefault();
    const { t } = this.props;
    if (this.validator.allValid()) {
      var username = this.state.userName.replace(/ /g, '');
      var password = this.state.Password.replace(/ /g, '');
      var url = `/admission/status/${username}/${password}/`
      this.context.updateValue("val", url);
      var self = this;
      window.setTimeout(function () {
        var stu_data = self.context;
        var stu_datas = stu_data && stu_data.state && stu_data.state.val || [];
        var data = stu_datas && stu_datas.data || [];
        if (Object.keys(data).length > 0) {
          self.setState({
            status: true,
            application_nb: data && data.application_nb || "",
            name: data && data.name || "",
            course: data && data.course || "",
            batch: data && data.batch || "",
            userStatus: data && data.status || ""
          })
        } else {
          self.setState({
            Password: "",
            userName: "",
          })
          let color = { background: '#ff0000', text: "#FFFFFF" };
          notify.show(t("ver_sta_err"), "custom", 5000, color);
        }

      }, 500)
    } else {
      let color = { background: '#ff0000', text: "#FFFFFF" };
      notify.show(t("val_err"), "custom", 5000, color);
      this.validator.showMessages();
      this.forceUpdate();
    }
  }

  render() {
    const {
      application_nb,
      name,
      course,
      batch,
      userStatus,
      status
    } = this.state;
    const { t } = this.props;
    return (
      <>
        <Header data={"Home"} />
        <div style={{
          background: "#03204e",
          /*background: "-webkit-linear-gradient(to right, #03204e, #348F50)",
          background: "linear-gradient(to right, #03204e, #348F50)"*/
        }}>
          <br />
          <div className="mb-3 ml-5 mr-5 mt-5 status-filter" >
            <div className="card mb-5 mt-5" >
              <Notifications options={{ left: '50px', top: '200px' }} />
              <div className="card-header text-center">
                <div className="row mt-5 mb-4">
                  <div className="col-md-2 form-group">
                    <label className="float-md-right"><b>{t("app_no")}</b><span style={{ color: "#b80b0b" }}> *</span></label>
                  </div>
                  <div className="col-md-3 form-group">
                    <input type="text" className="form-control ml-3" autoComplete="new-password" placeholder={t("app_no")} id="userName" onChange={this.handleUserData} value={this.state.userName} maxLength="150" />
                    <div style={{ color: "red" }}>{this.validator.message('Username', this.state.userName, 'required')}</div>
                  </div>
                  <div className="col-md-2 form-group">
                    <label className="float-md-right"><b>{t("password_lbl")}</b><span style={{ color: "#b80b0b" }}> *</span></label>
                  </div>
                  <div className="col-md-3 form-group">
                    <input type="text" className="form-control ml-3" autoComplete="new-password" placeholder="dd-mm-yyyy" id="Password" onChange={this.handleUserData} value={this.state.Password} maxLength="50" />
                    <div style={{ color: "red" }}>{this.validator.message('Password', this.state.Password, 'required')}</div>
                  </div>
                  <div className="col-md-2 form-group">
                    <button type="button" className="btn btn-sm  btn-primary" title={t("ver_sta_lbl")} onClick={this.submitUserDetails.bind(this)}>{t("ver_sta_btn")}</button>
                  </div>
                </div>
                {
                  status === true ?
                    <>
                      <div className="row">
                        <div className="col md-3 text-right" >{t("app_no")} &nbsp; :</div>
                        <div className="col md-2 text-left">{application_nb}</div>
                        <div className="col md-2 text-right">{t("app_name")}  &nbsp; :</div>
                        <div className="col md-5 text-left">{name}</div>
                      </div>
                      <div className="row">
                        <div className="col md-3 text-right">{t("course_applied")} &nbsp; :</div>
                        <div className="col md-2 text-left">{course}</div>
                        <div className="col md-2 text-right">{t("course_batch")}&nbsp; :</div>
                        <div className="col md-5 text-left">{batch}</div>
                      </div>
                      <div className="row">
                        <div className="col md-3 text-right">{t("user_status")} &nbsp; :</div>
                        <div className="col md-2 text-left">{userStatus}</div>
                        <div className="col md-2"></div>
                        <div className="col md-5"></div>
                      </div>
                    </>
                    :
                    ""
                }
              </div>
            </div>
          </div>
          <br /><br />
        </div>
      </>
    );
  }
}

export default withTranslation()(Status)